import React from 'react';
import {noop} from 'lodash';

import RecordsScreen from '/component/layout/RecordsScreen';
import {CLIENT_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_ORDER_HISTORY} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import withRecordPopover from '../withRecordPopover';

import {AllOrganizationClientsContent} from './AllOrganizationClientsContent';
import reportPayload from './reportPayload';

interface AllOrganizationClientsReportProps {
  loadingData: {
    total?: number;
  };
  tt: (key: string, defaultValue?: string) => string;
  showRecordPopover: () => void;
}

export const AllOrganizationClientsReport = ({
  loadingData = {},
  tt = (key, defaultValue = '') => defaultValue,
  showRecordPopover = noop,
}: AllOrganizationClientsReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      title={tt('title', 'All Organization Clients')}
      description={tt(
        'description',
        'All Clients in your organization (includes Coaches).',
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={AllOrganizationClientsContent}
    />
  );
};

export default withHOC(
  withTranslation('report.allOrganizationClients'),
  withRecordPopover({
    reportPayload,
    popoverName: CLIENT_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_ORDER_HISTORY,
    popoverContentProps: {
      renderTitle: () =>
        withTranslation.ts('reportRecordTitle.orderHistory', 'Order History'),
    },
  }),
)(AllOrganizationClientsReport);
